"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDialogController = function ConfirmDialogController() {
  "ngInject";

  (0, _classCallCheck3.default)(this, ConfirmDialogController);
  var vm = this;
  vm.name = 'confirmDialog';
};

exports.default = ConfirmDialogController;


// WEBPACK FOOTER //
// ./client/app/common/confirmDialog/confirmDialog.controller.js